import React, { useEffect, useState } from 'react';
import SliderHeader from 'jd-library/SliderHeader';
import Button from 'jd-library/Button';
import Loader from 'jd-library/Loader';
import useOnScroll from 'jd-library/useOnScroll';
import CSSTransform from '../../common/transition/Animation';
import { connect } from 'react-redux';
import style from './bulk-upload-history-slider.scss';
import axios from 'axios';
import SliderWrapper from 'jd-library/SliderWrapper';
const HistoryRow = (props) => {
    const getOutletName = (accountId, outletId) => {
        if(!props.outletData || (props.outletData && !props.outletData.length)) {
            return ''
        }
        let outletname ,fullId = outletId + '-' +accountId;
        for (let i = 0; i < props.outletData.length; i++) {
            if(props.outletData[i].id == fullId) {
                outletname = props.outletData[i].name;
                break;
            }
        }
        return outletname;
    }

    const downloadErrorFile = (errorFileUrl) => {
        if(errorFileUrl) {
            const url = window.location.protocol + "//" + window.location.host + errorFileUrl;
            if (props.deviceData?.isIphoneApp && window?.webkit?.messageHandlers && window?.webkit?.messageHandlers["downloadFile"]) {
                window.webkit.messageHandlers["downloadFile"].postMessage(url);
                return true;
            } else {
                window.location.href = url;
            }
        }        
    }

    let errorUrl = '/marketplace/static/php/web/b2bWebsite.php?token=' + props.session.token + '&action=downloadErrorFile&errorFileId=' + props.data.errorFileId;
    let createDate = props.data.uploadTime, uploadDate, uploadTime, outletname;
    if(props.deviceData && props.deviceData.isIphoneApp && props.data.errorFilePath && !props.session.viaOmni) {
        errorUrl = props.data.errorFilePath + "?urlType=downloadFileOmni";
    }
    var dateObj = new Date(createDate);
    uploadTime = dateObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    uploadDate = dateObj.getDate() + ' ' + dateObj.toLocaleString('default', { month: 'short' });
    let errorCnt = props.data.errorCnt || props.data.errorCount;
    let totalCnt = props.data.totalCnt || props.data.totalCount;
    let filename = props.data.filename || props.data.fileName;
    if(filename.includes('_')) {
        filename = filename.replace(/_/g, '_'+String.fromCharCode(8202));
    }
    if(filename.includes('-')) {
        filename = filename.replace(/-/g, '-'+String.fromCharCode(8202));
    }
    let status = props.data.status;
    if (status == 'UPDATE_FAILED') {
        status = 'FAILED'
    }
    if (status == 'COMPLETED') {
        status = 'DONE'
    }
    if (status == 'PARTIALLY_COMPLETED') {
        status = 'PARTIAL'
    }
    return (
        <div className='history-row'>
            <div className='history-row-icon'>
                {status == 'DONE' && <i className='icon-Checkmark success'></i>}
                {status == 'PARTIAL' && <i className='icon-alert_outline2 partial-success'></i>}
                {status == 'FAILED' && <i className='icon-alert_outline2 failed'></i>}
            </div>
            <div className='history-row-data'>
                <p className='file-name'>{filename}</p>
                {(props.isVendorImport && outletname) && 
                    <p className='outlet-name'>{outletname}</p>
                }
                {status == 'DONE' &&
                    <div className='upload-success-txt status-txt'>Upload Successful</div>
                }
                {status == 'PARTIAL' &&
                    <>
                        <div className='partial-upload-txt'>Partially Uploaded</div>
                        <div className='status-txt'>{totalCnt - errorCnt}/{totalCnt} {`${props.bulkUploadServices || props.session?.profileObject?.PluralLabelWithSpace} Uploaded`}</div>
                        <a><Button
                            size="xs"
                            variant="default"
                            className='download-btn'
                            onClick={()=>downloadErrorFile(errorUrl)}
                        >Download Error File</Button></a>
                    </>
                }
                {status == 'FAILED' &&
                    <>
                        <div className='failed-upload-txt'>Upload Failed</div>
                        <div className='status-txt'>{`No ${props.bulkUploadServices || props.session?.profileObject?.PluralLabelWithSpace} Uploaded`}</div>
                        <a><Button
                            size="xs"
                            variant="default"
                            className='download-btn'
                            onClick={()=>downloadErrorFile(errorUrl)}
                        >Download Error File</Button></a>
                    </>
                }
            </div>
            <div className='history-row-timestamp'>
                <div className='date'>{uploadDate}</div>
                <div className='time'>{uploadTime}</div>
            </div>
        </div>
    )
}

const BulkUploadHistorySlider = React.forwardRef((props) => {
    const [sliderShown, updateSliderFlag] = useState(false);
    let leftIcons = [
        {
            className: props.deviceData.isMobile  ? 'icon-hdrBackNew': 'icon-HDRback',
            onClick: () => {
                //updateSliderFlag(false)
                // window.history.back();
                props.onHidden && props.onHidden();
            }
        }
    ];
    let rightIconsWeb = [
        {
            className: 'icon-HDRcross',
            onClick: () => {
                updateSliderFlag(false);
                // window.history.back();
                props.onCrossClick();
            }
        }
    ];
    const [historyData, setHistoryData] = useState([]);
    const [showLoader, setLoader] = useState(false);
    const [isScroll, setScroll] = useState(false);
    const [nextPageLoading, setNextPageLoading] = useState(false);
    const [pageNo, setPageNo] = useState();
    const [maxPage, setMaxPage] = useState();
    let sliderBodyRef = React.useRef(null);
    let isMobile = props.deviceData.isMobile;
    let loaderStyle = {
        position: 'absolute', top: '45vh', left: '45vw', borderColor: '#0086FF', borderTopColor: '#fff', height: '10vw', width: '10vw'
    }
    useEffect(() => {
        setLoader(true);
        let url = '/marketplace/static/php/web/b2bWebsite.php?token=' + props.session.token + '&action=getUploadHistory&viaOmni='+(props.session.viaOmni ? '1':'0');
        axios({
            method: 'GET',
            url: url
        }).then((res) => {
            setLoader(false);
            updateSliderFlag(true);
            if(props.isVendorImport){
                setHistoryData(res.data.data ? res.data.data.results: []);
                setMaxPage(res.data.data.maxPages);
                setPageNo(res.data.data.pageNo);
            }
            else{
                setHistoryData(res.data.data);
            }
        })
    }, []);
    const nextPage = () => {
        let url = '/marketplace/inventory/ajax/service/getImportInventoryLogs.service?supplierId='+ props.session.supplierId +'&currentPage=' + (pageNo + 1) + '&pageSize=25&logFor=PRODUCTS&isMobile=true';
        axios({
            method: 'GET',
            url: url
        }).then((res) => {
            setNextPageLoading(false);
            let temp = historyData;
            if (res.data && res.data.data) {
                temp = temp.concat(res.data.data.results || []);
                setHistoryData(temp);
                setMaxPage(res.data.data.maxPages);
                setPageNo(res.data.data.pageNo);
            }
        })
    }
    useEffect(() => {
        if (nextPageLoading) {
            (pageNo < maxPage) && nextPage();
        }
    }, [nextPageLoading]);
    const handleScroll = (e) => {
        if (!e.currentTarget){
            return;
        }
        setScroll(e.currentTarget.scrollTop > 5);
        let scrollRemaining = (e.currentTarget.scrollHeight - e.currentTarget.scrollTop - document.scrollingElement.clientHeight);
        if(props.isVendorImport && !nextPageLoading && scrollRemaining < 150){
            setNextPageLoading(true);
        }
    }
    const handleScrollWeb = (scrollAmt) => {
        if (isMobile){
            return;
        }
        setScroll(scrollAmt.currScroll.scrollTop > 5);
    }
    useOnScroll({
		callback: (e, scrollAmt) => {
            handleScrollWeb(scrollAmt);
        },
        element: sliderShown ? sliderBodyRef : null,
        deps:[sliderShown]
	});
    useEffect(() => {
        setTimeout(() => {
            let scrollEle = document.querySelector('.history-slider > div > div');
            scrollEle && scrollEle.addEventListener('scroll', handleScroll);
            return () => {
                scrollEle && scrollEle.removeEventListener('scroll', handleScroll);
            };
        }, 100);
	}, []);
    return (
        <SliderWrapper
            slider={{
                className: 'history-slider',
                slideDirection: 'right'
            }}
            onHidden={props.onHidden}
        >
        <div ref={sliderBodyRef} className={`bulk-upload-history-container ${isMobile ? 'isMobile': 'isWeb'}`}>
            <SliderHeader
                className={'bulk-upload-history-header' + (isScroll?' scrolled':'')}
                heading={`${props.session?.profileObject?.SingleLabelWithSpace} Upload History`}
                headingClass='bulk-upload-history-heading'
                leftIcons={leftIcons}
                rightIcons={isMobile ? [] : rightIconsWeb}
                headingIconClass='header-class'
                variant='secondary'
            />
            <div className='bulk-upload-history-holder'>
                <CSSTransform>
                    <div className='bulk-upload-history-body'>
                        {(!historyData || historyData && historyData.length == 0) && !showLoader &&
                            <div className='no-history'>
                                <img src='https://image1.jdomni.in/jdomni_email/noProducts.svg'/>
                                <div className='not-found-label'>{`No ${props.session?.profileObject.SingleLabelWithSpace} Upload History`}</div>
                            </div>
                        }
                        {historyData && !showLoader ? historyData.map((data) => {
                            return (<HistoryRow {...props} data={data} bulkUploadServices = {data.type == 'service'}/>)
                        }) :null}
                        {showLoader && <Loader style={loaderStyle}/>}
                    </div>
                </CSSTransform>
            </div>
            {}
        </div>
        </SliderWrapper>
    )
});

const mapStateToProps = state => {
	return {
        session: state.session,
        bulkUpload: state.bulkUpload,
		deviceData: state.library.deviceData,
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(BulkUploadHistorySlider);